// extracted by mini-css-extract-plugin
module.exports = {"i18u073x":"i18u073x"};